import { Component } from "../../../components/base/Component";
import { ComponentFactory } from "../../../services/ComponentFactory";
import { ICfa } from "../../../models/ICfa";
import { API } from "../../../util/API";

export class SuspiciousActivity extends Component {
	form: HTMLFormElement;

	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);

		if (this._element.tagName !== "FORM") {
			throw new Error(`Non-form element passed in, element: ${this._element}`);
		}

		this.form = this._element as HTMLFormElement;
		// tslint:disable-next-line
		this.initialize();
	}

	private async initialize(): Promise<void> {
		this.applyValidationRules(this.form);
		this.form.addEventListener("submit", e => this.handleSubmission(e));
	}

	private applyValidationRules(form: HTMLFormElement): void {
		const messages = this._element.dataset;
		const errorClass = "hasError";

		$.validator.addMethod(
			"phoneUS",
			function (a, b) {
				return (
					(a = a.replace(/\s+/g, "")),
					a.length > 9 &&
						a.match(
							/^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]\d{2}-?\d{4}$/
						)
				);
			},
			"Please specify a valid phone number"
		);

		const baseValidations = {
			fName: {
				required: true
			},
			lName: {
				required: true
			},
			phone: {
				required: true,
				phoneUS: true
			},
			email: {
				email: true,
				required: true
			},
			addtionalDetails: {
				required: true,
				minlength: 5
			}
		};

		$(form).validate({
			errorClass: "hasError",
			errorPlacement: (error, element) => {
				error.appendTo(element.next(".error-container"));
			},
			highlight: element => {
				$(element).parent().addClass(errorClass);
			},
			messages: {
				fname: {
					required: messages.customNameMsg ?? ""
				},
				lname: {
					required: messages.customNameMsg ?? ""
				},
				phone: {
					required:
						messages.customPhoneMsg ?? "Please enter a valid phone number"
				},
				email: messages.customEmailMsg ?? "",
				additionalDetails: {
					required: messages.customAdditionalMsg ?? ""
				}
			},
			rules: baseValidations,
			unhighlight: element => {
				$(element).parent().removeClass(errorClass);
			}
		});
	}

	private async handleSubmission(e: Event): Promise<void> {
		const { recaptchaEndpoint } = this._element.dataset;

		e.preventDefault();
		this.toggleSubmitBtn(false);
		const formHasErrors = !this.validate();

		if (formHasErrors) {
			this.toggleSubmitBtn(true);

			return;
		}

		await this.submitForm();
	}

	private async submitForm(): Promise<null | object> {
		const {
			recaptchaEndpoint,
			submissionEndpoint = "",
			formDatasourceId = "",
			redirectSuccess,
			redirectError
		} = this._element.dataset;
		const payload = $(this.form)
			.serializeArray()
			.reduce(
				(ac, cv) => {
					// Only included in form when checked
					if (cv.name === "flagCheck") {
						return { ...ac, [cv.name]: true };
					}

					return { ...ac, [cv.name]: cv.value };
				},
				{ flagCheck: false, formDatasourceId }
			);
		console.log({ payload });
		const recaptchaVal = payload["g-recaptcha-response"];

		if (!recaptchaVal) {
			console.warn(
				`No recaptcha value found in payload: ${JSON.stringify(payload)}`
			);
			alert(
				"There was a problem retrieving the recaptcha response. Please try again."
			);
			return null;
		}

		const promise = $.ajax({
			contentType: "application/json",
			data: JSON.stringify({
				recaptchaGuid: payload["g-recaptcha-response"]
			}),
			type: "POST",
			url: recaptchaEndpoint
		});

		const recaptchaResult = await Promise.resolve(promise);

		if (!recaptchaResult) {
			console.warn("Recaptcha failed.");
			this.toggleRecaptchaErr(true);
			this.toggleSubmitBtn(true);

			return null;
		}

		const [result, err] = await API.postReq(submissionEndpoint, payload);

		console.log({ result });
		console.log({ err });

		if (err || !result) {
			console.warn("Error in submitting form.");
			//alert("Error in submitting form. Please try again.");

			window.location.href = redirectError;
		}
		else {
			window.location.href = redirectSuccess;
		}

		return result;
	}

	private validate(): boolean {
		if (this._element) {
			return $(this._element).valid();
		}

		return false;
	}

	private toggleRecaptchaErr(toggleOn: boolean): void {
		const recaptchaField = this._element.querySelector(
			"[data-element='recaptchaField']"
		);

		if (!recaptchaField) {
			console.warn("No recaptcha field found. Check DOM.");

			return;
		}

		toggleOn
			? recaptchaField.classList.add("display")
			: recaptchaField.classList.remove("display");
	}

	private toggleSubmitBtn(toggleOn: boolean): void {
		const submitBtn = this._element.querySelector("button[type='submit']");
		const disabledClass = "disabled";

		if (!submitBtn) {
			throw new Error(`Submit button not found for ${submitBtn}`);
		}

		toggleOn
			? submitBtn.classList.remove(disabledClass)
			: submitBtn.classList.add(disabledClass);
	}
}

ComponentFactory.registerComponent("suspiciousActivity", SuspiciousActivity);
